<template>
  <div></div>
</template>

<script>
import { globalStore } from '@/main'

export default {
  name: 'Logout',
  mounted () {
    let cmp = this
    cmp.$store.dispatch('logoutUser').then(() => {
      cmp.$router.push('/login')
    })
  }
}
</script>
